<div class="auth-wrapper" [class.auth-pending]="requestPending">
  @if (signInMessage) {
    <p class="sign-in-message body-14"
      [class.error]="signInMessage.kind === 'error'">
      {{ signInMessage.key | translate }}
    </p>
  }

  @if (contractLinkOffered) {
    <button class="contract-link-button button link text-button-12"
      (click)="openContractLinkModal()">
      {{ 'auth.contract-link.title' | translate }}
    </button>
  }

  <div class="lang-header">
    @for (l of langs; track l) {
      <button
        class="lang-btn"
        [class.active]="l === currentLang"
        (click)="setLang(l)">
        {{ l.toUpperCase() }}
      </button>
    }
  </div>

  @if (renderAuthenticator) {
    <amplify-authenticator [initialState]="initialState" [signUpAttributes]="signUpFields" [socialProviders]="socialProviders" [formFields]="formFields" [services]="services">
      <ng-template amplifySlot="sign-in-header">
        <div class="flex flex-center">
          <img
            class="amplify-image"
            alt="Amplify logo"
            src="assets/calingo-logo-green.svg"
            />
          </div>
        </ng-template>
        <ng-template amplifySlot="sign-up-header">
          <div class="flex flex-center">
            <img
              class="amplify-image"
              alt="Amplify logo"
              src="assets/calingo-logo-green.svg"
              />
            </div>
            @if (pendingSignUpEmail) {
              <p class="pending-sign-up-hint body-14">
                {{ 'auth.sign-up.pending-hint' | translate: { email: pendingSignUpEmail } }}
              </p>
            }
          </ng-template>
          <!-- Inside the authenticator's <form>: every button here needs type="button",
          or it submits the code. -->
          <ng-template amplifySlot="confirm-sign-up-footer">
            <div class="code-email-search body-12">
              <span>{{ 'auth.code-email-help.inline' | translate }}</span>
              <span class="search-query">
                <code>{{ codeEmailSearchQuery }}</code>
                <button class="button icon-only"
                  type="button"
                  [attr.aria-label]="'auth.code-email-help.copy' | translate"
                  [cdkCopyToClipboard]="codeEmailSearchQuery"
                  (cdkCopyToClipboardCopied)="onSearchQueryCopied()">
                  <mat-icon svgIcon="copy"></mat-icon>
                </button>
                <!-- Only in the page while it shows, so a text selection does not pick it up. -->
                @if (searchQueryCopied) {
                  <span class="copy-feedback">
                    {{ 'auth.code-email-help.copied' | translate }}
                  </span>
                }
              </span>
              <button class="info-button"
                type="button"
                [attr.aria-label]="'auth.code-email-help.more' | translate"
                (click)="openCodeEmailHelp()">
                <span class="info-icon">
                  <mat-icon svgIcon="i-icon"></mat-icon>
                </span>
              </button>
            </div>
          </ng-template>
          <ng-template amplifySlot="forgot-password-header">
            <div class="flex flex-center">
              <img
                class="amplify-image"
                alt="Amplify logo"
                src="assets/calingo-logo-green.svg"
                />
              </div>
            </ng-template>
            <ng-template
              amplifySlot="authenticated"
              let-user="user"
              let-signOut="signOut"
              >
              <h1>{{ 'common.welcome-message' | translate }}</h1>
            </ng-template>
          </amplify-authenticator>
        }
      </div>

      @if (authStatus=== 'unauthenticated') {
        <div class="footer">
          <p class="body-16">
            <a class="contact-us-link" href="https://pet.calingo.ch/kontakt"
            target="_blank">{{ 'auth.contact-us' | translate }}</a>
          </p>
        </div>
      }
